import type { TextLargeParagraphTitleProps } from '@carboncopyco/ui';
import { TextSubHeader } from '@carboncopyco/ui';
import type React from 'react';

export interface RulesManagerHeaderProps {
  children: React.ReactNode;
}

export const RulesManagerHeader = ({ children }: RulesManagerHeaderProps) => {
  return (
    <div
      id="rules-manager-header"
      className="flex"
    >
      {children}
    </div>
  );
};

type RulesManagerHeaderTitleProps = Pick<TextLargeParagraphTitleProps, 'label'>;

const RulesManagerHeaderTitle = ({ label }: RulesManagerHeaderTitleProps) => {
  return (
    <div className="flex items-center flex-grow">
      <TextSubHeader
        label={label}
        color="text-ds-natural-600"
      />
    </div>
  );
};

RulesManagerHeader.Title = RulesManagerHeaderTitle;

export interface RulesManagerHeaderActionProps {
  children: React.ReactNode;
}

const RulesManagerHeaderAction = ({
  children,
}: RulesManagerHeaderActionProps) => {
  return <div className="flex-shrink-0">{children}</div>;
};

RulesManagerHeader.Action = RulesManagerHeaderAction;
